module.exports = __webpack_public_path__ + "img/6232b0f9ac5f816f919c5cd07e10860b.jpg";